import cn from 'classnames'
import s from 'pages/common.module.scss'
import { Element, animateScroll as scroll } from 'react-scroll'
import { Button } from 'react-bootstrap'
import { useAppSelector } from 'redux/hooks'
import { Status as StatusParcelle } from 'redux/features/parcelle/slice'
import { Status as StatusFavoris } from 'redux/features/favoris/slice'
import { makeSelectParcelles } from 'redux/features/parcelle/selectors'
import { makeSelectStatus } from 'redux/features/favoris/selectors'

import useBienAVendre from 'hooks/useBienAVendre'
import useToggle from 'hooks/useToggle'
import Parcelle from 'entity/Parcelle'

import TripleGrow from 'components/Loading/TripleGrow'
import CardParcelle from 'components/Card/Card/CardParcelle'
import VousNeTrouvezPasVotreResultat from 'components/Modal/VousNeTrouvezPasVotreResultat'
import BeaucoupDeResultats from 'pages/BiensAVendre/components/BeaucoupDeResultats/BeaucoupDeResultats'

import useFiltreBienAVendre from 'hooks/useFiltreBienAVendre'

const ResultatListeSection = (): JSX.Element | null => {
  const { statusParcelle } = useBienAVendre()
  const { estRetireParLeFiltrage } = useFiltreBienAVendre()
  const parcelles = useAppSelector(makeSelectParcelles)
  const statusFavoris = useAppSelector(makeSelectStatus)

  const [doNotFindResultModal, toggleDoNotFindResultModal] = useToggle()

  const scrollToTop = () =>
    scroll.scrollToTop({ containerId: 'parcelle-list-result' })

  return (
    <div id="parcelle-list-result" className={cn(s.parcelleListResult)}>
      <div className={s.wrapper}>
        {/* Display the loader while the modal BeaucoupDeResultats is open */}
        {((statusParcelle !== StatusParcelle.ShowParcelleResults &&
          statusParcelle !== StatusParcelle.Idle) ||
          statusFavoris === StatusFavoris.Pending) && (
          <TripleGrow className={s.loading} />
        )}
        {statusParcelle === StatusParcelle.ShowParcelleResults &&
          !parcelles.length && (
            <p className={s.noResult}>
              Aucun résultat ne correspond à votre recherche.
            </p>
          )}
        {statusParcelle === StatusParcelle.ShowParcelleResults &&
          statusFavoris === StatusFavoris.Succeeded &&
          parcelles.length &&
          parcelles.map((parcelle: Parcelle, idx) => {
            if (estRetireParLeFiltrage(parcelle.uid)) {
              return null
            }

            return (
              <Element
                name={parcelle.uid}
                key={parcelle.uid}
                className={s.cardParcelleWrapper}
              >
                <CardParcelle
                  count={{ index: idx, total: parcelles.length }}
                  parcelle={parcelle}
                />
              </Element>
            )
          })}
        <BeaucoupDeResultats />
      </div>
      <div className={cn(s.resultBannerBottom)}>
        <VousNeTrouvezPasVotreResultat
          show={doNotFindResultModal}
          onHide={toggleDoNotFindResultModal}
        />
        <Button variant="link" onClick={() => toggleDoNotFindResultModal()}>
          Vous ne trouvez pas votre résultat ?
        </Button>
        <Button variant="link" onClick={scrollToTop}>
          Retour en haut
        </Button>
      </div>
    </div>
  )
}

export default ResultatListeSection
